(() => {
  const root = document.querySelector('#kazoku-rakutabikon');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  root.querySelectorAll('.js-fadein').forEach((el) => {
    if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('-show');
    else new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('-show'); observer.unobserve(entry.target); }
      });
    }, { rootMargin: '-10% 0px' }).observe(el);
  });

  root.querySelectorAll('.js-scroll-to').forEach((link) => {
    const target = root.querySelector(link.getAttribute('href'));
    if (!target) return;
    link.addEventListener('click', (event) => {
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        root.querySelectorAll('.js-scroll-to').forEach((item) => item.classList.remove('-active'));
        link.classList.add('-active');
      }
    }).observe(target);
  });

  if (typeof Swiper !== 'undefined') {
    const makeSlider = (selector, pagination, next, prev, options = {}) => {
      const el = root.querySelector(selector);
      if (!el) return;
      new Swiper(el, Object.assign({
        slidesPerView: 1.46, centeredSlides: true, spaceBetween: 10, speed: 1000,
        pagination: { el: root.querySelector(pagination), type: 'bullets', clickable: true },
        navigation: { nextEl: root.querySelector(next), prevEl: root.querySelector(prev) }
      }, options));
    };
    makeSlider('.js-location-resort', '.swiper-pagination.-resort', '.swiper-button-next.-resort', '.swiper-button-prev.-resort');
    makeSlider('.js-location-city', '.swiper-pagination.-city', '.swiper-button-next.-city', '.swiper-button-prev.-city');
    makeSlider('.js-voice', '.swiper-pagination.-voice', '.swiper-button-next.-voice', '.swiper-button-prev.-voice', { slidesPerView: 1, spaceBetween: 40 });
  }
})();
